module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "dedication"
    }
  }, [_c('h1', [_vm._v("Dedication")]), _vm._v(" "), _c('p', [_vm._v("Dedicated to all of those who are riding the waves of uncertainty, trying to grasp reality, and hoping for a future free of concern.")]), _vm._v(" "), _c('p', [_vm._v("You are not alone in your thoughts. I’m here, C. Platt.")]), _vm._v(" "), _c('p', [_vm._v("Angelo and my two sweet babies, Marley and Milo. You give me the strength to carry on and fight. Also, my parents and family for continuing to stand by my side and help me navigate the up and downs of my illness.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f1ba640","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch002.vue
// module id = 66
// module chunks = 0